import { LoadingSpinner } from '@/components/ui/loading-spinner';

const PageLoadingFallback = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-sm text-muted-foreground">Loading page...</p>
      </div>
    </div>
  );
};

export default PageLoadingFallback;
